import React, { useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { DispatchType } from '../../../state/configureStore';
import { Container, Row } from 'reactstrap';
import { searchInObject } from '../../../core/helpers/search';
import { ApplicationState } from '../../../state/ApplicationState';
import { ClipLoader } from '../../components/ClipLoader';
import { TachoConfirmationModal } from '../../components/TachoConfirmationModal';
import { LicenseTermsTable } from './components/LicenseTermsTable';
import { LicenseTermsToolbar } from './components/LicenseTermsToolbar';
import { LicenseTerm } from '../../../core/domainModels/licenseTerms/LicenseTerm';
import { AddLicenseTermModal } from '../../modals/licenseTerms/AddLicenseTermModal';
import { deleteLicenseTermThunk, fetchLicenseTermsThunk } from '../../../state/licenseTerms/reducer';
import { UpdateLicenseTermModal } from '../../modals/licenseTerms/UpdateLicenseTermModal';

export const LicenseTermsPage = () => {
    const dispatch = useDispatch<DispatchType>();
    const licenseTerms = useSelector((state: ApplicationState) => state.licenseTerms.licenseTerms);
    const fetchUsersPending = useSelector((state: ApplicationState) => state.licenseTerms.fetchLicenseTermsPending);
    const deleteUsersPending = useSelector((state: ApplicationState) => state.licenseTerms.deleteLicenseTermPending);
    const deleteUsersError = useSelector((state: ApplicationState) => state.licenseTerms.deleteLicenseTermError);
    const [isConfirmRemoveModalOpen, setIsConfirmRemoveModalOpen] = useState(false);
    const [isOpenAddDistributorModal, setIsOpenAddDistributorModal] = useState(false);
    const [isOpenUpdateModal, setIsOpenUpdateDistributorModal] = useState(false);
    const [selectedLicenseTerms, setSelectedLicenseTerms] = useState<Array<LicenseTerm>>([]);
    const [searchQuery, setSearchQuery] = useState('');
    const licenseTermsToShow = useMemo(() => {
        return searchQuery ? licenseTerms.filter((term: LicenseTerm) => searchInObject(term, searchQuery)) : licenseTerms;
    }, [licenseTerms, searchQuery]);
    return (
        <Container fluid className="flexColumnFullHeightContainer">
            <LicenseTermsToolbar
                selected={selectedLicenseTerms}
                openAddModal={() => setIsOpenAddDistributorModal(!isOpenAddDistributorModal)}
                openUpdateModal={() => setIsOpenUpdateDistributorModal(!isOpenUpdateModal)}
                openConfirmRemoveModal={() => setIsConfirmRemoveModalOpen(!isConfirmRemoveModalOpen)}
                onRefresh={() => dispatch(fetchLicenseTermsThunk())}
                onSearchQueryChanged={setSearchQuery}
            />
            <Row className="ag-theme-balham tabTable flexGrowScrollableChild g-0">
                {fetchUsersPending ? (
                    <ClipLoader />
                ) : (
                    <LicenseTermsTable
                        onDoubleClicked={() => setIsOpenUpdateDistributorModal(!isOpenUpdateModal)}
                        onSelectionChanged={setSelectedLicenseTerms}
                        licenseTerms={licenseTermsToShow}
                    />
                )}
            </Row>
            <TachoConfirmationModal
                isOpen={isConfirmRemoveModalOpen}
                onSubmit={() => dispatch(deleteLicenseTermThunk(selectedLicenseTerms[0].id))}
                onToggle={() => setIsConfirmRemoveModalOpen(!isConfirmRemoveModalOpen)}
                message={'licenseTermsRemoveConfirmationMessage'}
                pending={deleteUsersPending}
                errorToTranslate={deleteUsersError}
                title={'licenseTermsDelete'}
            />
            <AddLicenseTermModal
                isOpen={isOpenAddDistributorModal}
                onToggle={() => setIsOpenAddDistributorModal(!isOpenAddDistributorModal)}
            />

            <UpdateLicenseTermModal
                isOpen={isOpenUpdateModal}
                licenseTerm={selectedLicenseTerms[0]}
                onToggle={() => setIsOpenUpdateDistributorModal(!isOpenUpdateModal)}
            />
        </Container>
    );
};
